import service from "@/api/service";
import { GetResponse } from "@/api/point-fuyo/response";
import { GetRequest } from "@/api/point-fuyo/request";

/**
 * ポイントカード付与ポイント設定取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-point-fuyo", getRequest);
  return response.data as GetResponse;
}
